// CD-5270 Home dashboard — pure mapping helpers (no JSX; plain functions, no type annotations).

// SystemAlert SeverityLevel -> announcement modifier class + FA icon.
// Convention (matches HomeAnnouncements + SystemAlertItem.getSeverityLevelContent):
//   1 = Critical (red), 2 = Warning (gold), 3 = Info (green).
// (The SystemAlert.sql column comment is the inverse and is outdated — we follow the frontend.)
export function announceSeverity(severityLevel) {
  switch (Number(severityLevel)) {
    case 1:
      return { cls: 'crit', icon: 'fa-solid fa-circle-exclamation' };
    case 3:
      return { cls: 'info', icon: 'fa-solid fa-circle-info' };
    case 2:
    default:
      return { cls: '', icon: 'fa-solid fa-triangle-exclamation' };
  }
}

// JiraIssue StatusName -> dev-status pill class. Grouping mirrors JiraIssueConstants
// (Testing bucket folds Awaiting approval / Merge* / To Merge / Merged into Develop).
const STATUS_PILL = {
  'To Do': 'todo',
  'In Progress': 'progress',
  UAT: 'uat',
  Testing: 'testing',
  'Awaiting approval': 'testing',
  'Merge approved': 'testing',
  'Merge rejected': 'testing',
  'To Merge': 'testing',
  'Merged into Develop': 'testing',
};
export function statusPillClass(statusName) {
  return STATUS_PILL[statusName] || 'todo';
}

// UserLink BackColor (bootstrap colour name) -> .plink brand variant.
// Real data: success -> BambooHR (green), primary -> BARE (blue), rest default.
export function linkVariant(backColor) {
  switch ((backColor || '').toLowerCase()) {
    case 'success':
      return 'v-green';
    case 'primary':
      return 'v-blue';
    case 'secondary':
    case 'dark':
    case 'navy':
      return 'v-navy';
    default:
      return '';
  }
}
